"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : COPY FIELD : STYLES --------------- ++++++++++ */


var _default = {
  copyfield: {
    transition: _index.theme.animation.general('all'),
    '& .field': {
      flex: '1',
      width: '100%'
    },
    '& .cta': {
      width: (0, _index.pxToEm)(90),
      '& .icon': {
        fontSize: '75%'
      }
    },
    '& .buttonlink': {
      display: 'flex'
    },
    '& .show-link-true': {
      display: 'flex',
      '& .link': {
        fontSize: (0, _index.pxToEm)(14),
        textDecoration: 'underline'
      }
    },
    // ----- states ----- //
    '&.copied-true': {
      extend: _index.disable,
      '& .cta': {
        width: 'auto'
      }
    },
    // ----- props ----- //
    '&.ctaPosition': {
      '&-inline': {
        display: 'flex',
        flexDirection: 'row',
        '& .field': {
          marginRight: function marginRight(props) {
            return (0, _index.replacePXinStringWithEM)("".concat(props.spaceBetweenFieldAndButton));
          }
        },
        '& .button': {
          marginRight: (0, _index.pxToEm)(32)
        }
      },
      '&-block': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: 'auto',
        '& .field': {
          marginBottom: function marginBottom(props) {
            return (0, _index.replacePXinStringWithEM)("".concat(props.spaceBetweenFieldAndButton));
          }
        },
        '& .ctas': {
          display: 'flex',
          justifyContent: 'flex-start',
          marginRight: (0, _index.pxToEm)(32)
        }
      }
    },
    '&.fieldHeight': {
      '&-inline': {
        alignItems: 'center',
        whiteSpace: 'nowrap'
      },
      '&-short': {
        alignItems: 'flex-end',
        '& .field .formelement': {
          height: (0, _index.pxToEm)(75)
        }
      },
      '&-medium': {
        alignItems: 'flex-end',
        '& .field .formelement': {
          height: (0, _index.pxToEm)(120)
        }
      },
      '&-tall': {
        alignItems: 'flex-end',
        '& .field .formelement': {
          height: (0, _index.pxToEm)(170)
        }
      }
    }
  }
};
exports.default = _default;